import type { ReactNode } from 'react'

type LimeChipProps = {
  /** Diameter in px, taken straight from the design. */
  size: number
  children: ReactNode
}

/** The lime circle that backs every stat card icon. */
export const LimeChip = ({ size, children }: LimeChipProps) => (
  <span
    className="flex shrink-0 items-center justify-center rounded-full bg-dash-lime"
    style={{ width: size, height: size }}
  >
    {children}
  </span>
)
